export default "__VITE_ASSET__BbI2RCHB__"